// import Swiper bundle with all modules installed FULLと軽量のものがある
//import Swiper from "swiper/bundle";
// import Swiper, { Navigation, Pagination } from "swiper";
import Swiper, { Autoplay } from "swiper";
// Swiper.use([Navigation, Pagination]);
Swiper.use([Autoplay]);

export function swiper() {
  // Initialize Swiper
  let swiper_pc = new Swiper(".swiper-container-pc", {
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: {
      delay: 3000,
    },
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  let swiper_sp = new Swiper(".swiper-container-sp", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 3000,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  let swiper_front = new Swiper(".swiper-front", {
    centeredSlides: true,
    slidesPerView: "2",
    // spaceBetween: 100,
    // pagination: {
    //   el: ".swiper-pagination",
    //   clickable: true,
    // },
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    // paginationClickable: true,
    speed: 2000,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    loop: true,
    breakpoints: {
      // 0px以上の場合
      0: {
        spaceBetween: 12,
        slidesPerView: "1.5",
      },
      // 576px以上の場合
      576: {
        spaceBetween: 24,
      },
      // 1200px以上の場合
      1200: {
        spaceBetween: 100,
      },
    },
  });
}
